import styled, { css } from "styled-components"

import Pc from "~/components/atoms/Pc"
import Sp from "~/components/atoms/Sp"
// import Link from "~/components/atoms/Link"
import { Container as _Container } from "~/components/layouts/Container"
import {
  Color,
  IsMobile,
  IsPC,
  LineHeight, // Transition,
  RadiusSize,
  SpacingSize,
  TextSize,
} from "~/consts/style-mixins"
import { staticPath } from "~/services/helper"

interface Props {
  items: item[]
}

interface item {
  img: string
  name: string
  position: string
  introduction: string
}

const Teacher = ({ items }: Props) => {
  return (
    <Container size="Large">
      <Pc>
        <img src={staticPath("/static/images/course/teacher-pc.svg")} />
      </Pc>
      <Sp>
        <img src={staticPath("/static/images/course/teacher-sp.svg")} />
      </Sp>
      <ul>
        {items.map((item: item, index) => {
          return (
            <li key={index} className="teacher">
              <img src={item.img} className="teacher-img" />
              <div className="teacher-text">
                <p className="teacher-text-position">{item.position}</p>
                <p className="teacher-text-name">{item.name}</p>
                <p className="teacher-text-introduction">{item.introduction}</p>
              </div>
            </li>
          )
        })}
      </ul>
    </Container>
  )
}

const Container = styled(_Container)`
  ${IsPC(css`
    padding: 96px 16px;
  `)}
  ${IsMobile(css`
    padding: 48px 16px;
  `)}
  .teacher {
    display: flex;
    align-items: center;
    margin-top: ${SpacingSize["4XL"]}px;
    ${IsMobile(css`
      margin-top: 32px;
    `)}
    &:nth-child(odd) {
      ${IsMobile(css`
        flex-direction: column;
      `)}
      .teacher-text {
        margin-left: ${SpacingSize["4XL"]}px;
        ${IsMobile(css`
          margin-left: 0;
        `)}
      }
    }
    &:nth-child(even) {
      flex-direction: row-reverse;
      ${IsMobile(css`
        flex-direction: column;
      `)}
      .teacher-text {
        margin-right: ${SpacingSize["4XL"]}px;
        ${IsMobile(css`
          margin-right: 0;
        `)}
      }
    }
  }
  .teacher-img {
    border-radius: 50%;
    width: 240px;
    height: 240px;
    object-fit: cover;
  }
  .teacher-text {
    ${IsPC(css`
      width: calc(100% - 408px);
    `)}
    ${IsMobile(css`
      margin-top: 16px;
    `)}
  }
  .teacher-text-name {
    font-size: ${TextSize["4XL"]}px;
    font-weight: bold;
    line-height: ${LineHeight.S}%;
    ${IsMobile(css`
      font-size: 20px;
    `)}
  }
  .teacher-text-position {
    font-size: ${TextSize.M}px;
    line-height: ${LineHeight.L}%;
  }
  .teacher-text-introduction {
    font-size: ${TextSize.M}px;
    line-height: ${LineHeight.L}%;
    color: ${Color.Gray};
    margin-top: ${SpacingSize.M}px;
    ${IsMobile(css`
      font-size: 14px;
      margin-top: 8px;
    `)}
  }
`

export default Teacher
